import React, { useState } from 'react';
import {
  Button, FormGroup, Input, Label, ModalFooter,
} from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import recommend2FA from '../../assets/img/other/second_factor_enable.svg';
import ModalComponent from './ModalComponent';
import { disableTFANotification, showModal } from '../../utils/helpers/actions';

const EnableTwoFAModal = ({
  onToggle, isOpen, disableTFANotification, showModal, email,
}) => {
  const [check, onChangeCheck] = useState(false);
  const onEnable = () => {
    if (check) disableTFANotification(email);
    showModal('TFAPassword');
  };

  const onCancel = () => {
    if (check) disableTFANotification(email);
    onToggle();
  };

  return (
    <ModalComponent
      title="Second factor verification"
      image={recommend2FA}
      isOpen={isOpen}
      onToggle={onToggle}
      name="EnableTwoFA"
    >
      <p className="modal-text font-16 m-0 text-center">
        We recommend you activate your second factor verification to guard your details safely
      </p>
      <FormGroup check className="checkbox d-flex align-items-center justify-content-center mt-4 pt-2 p-0">
        <Input
          className="form-checkbox"
          type="checkbox"
          id="checkbox1"
          name="checkbox1"
          value={check}
          onChange={() => onChangeCheck(!check)}
        />
        <Label check className="form-check-label font-14 subtext" htmlFor="checkbox1">
          Don’t show this message again
        </Label>
      </FormGroup>
      <ModalFooter className="border-0 p-0 flex-column">
        <Button className="m-0 issuer-button-primary" size="lg" block onClick={onEnable}>Enable</Button>
        <Button className="m-0 mt-1" size="lg" color="link" block onClick={onCancel}>Do it later</Button>
      </ModalFooter>
    </ModalComponent>
  );
};

EnableTwoFAModal.propTypes = {
  onToggle: PropTypes.func.isRequired,
  disableTFANotification: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
};

const mapStateToProps = ({ auth: { user } }) => ({
  email: user.email,
});

export default connect(
  mapStateToProps,
  {
    disableTFANotification,
    showModal,
  },
)(EnableTwoFAModal);
